import type { Asr } from '@polyai/stream/protobuf/asr';
import type {
  AudioEnhancement,
  BargeInConfig,
  FillerUtterances,
  VADConfig,
} from '@polyai/stream/protobuf/channels';
import type {
  DisclaimerMessage,
  Greeting,
} from '@polyai/stream/store/reducers/agent-settings/types';
import type { AsrSettings } from '@polyai/stream/store/reducers/asr-settings/types';
import type { ContentFilterSettingsType } from '@polyai/stream/store/reducers/content-filter-settings/types';
import type { LLMSettingsType } from '@polyai/stream/store/reducers/llm-settings/types';

export interface StylePrompt {
  prompt: string;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
}

export interface ChannelConfig {
  llmSettings: LLMSettingsType;
  stylePrompt: StylePrompt;
  greeting: Greeting;
  safetyFilters: ContentFilterSettingsType;
}

export enum ChannelType {
  VOICE = 0,
  WEB_CHAT = 1,
}

export enum ChannelStatus {
  NOT_CREATED = 0,
  CREATED = 1,
}

export interface VoiceChannel {
  config: ChannelConfig;
  asrSettings: AsrSettings;
  disclaimer: DisclaimerMessage;
  vadConfig?: VADConfig;
  audioEnhancement?: AudioEnhancement;
  silenceFillerUtterances?: FillerUtterances;
  asrConfig?: Asr;
  bargeInConfig?: BargeInConfig;
}

export interface WebChatChannel {
  config: ChannelConfig;
  status: ChannelStatus;
}

export interface Channels {
  voice: VoiceChannel;
  webChat: WebChatChannel;
}
